import { notification } from 'antd';
import './style.less';

const snackbar = (message, type = 'success') => {
  const styles = {
    success: {
      background: 'var(--green-5)',
    },
  };

  notification.open({
    message,
    style: styles[type],
    placement: 'bottomLeft',
    className: 'snackbar-notification',
    closeIcon: null,
    duration: 4,
  });
};

export default snackbar;
